const is_prod = true;

const server =  is_prod ? "https://anymeet.onrender.com" : "http://localhost:8000"

export default server;